module.exports = __webpack_public_path__ + "audit_trail.ee4b0203caf140045908017079f2d029.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/audit_trail.svg
// module id = 351
// module chunks = 0